import { CreateBatchDTO } from "./createBatchDTO";
import { PlateScanDTO } from "./plateScanDTO";

export class GenericMultiPlateUpdateDTO{
    labID!: string;
	processStepName!: string;
	puid!: string	
	updateType!: string;
	actionName!: string;
	nextActionName!: string;
	actionType!: string;
	nextActionType!: string;
	runtime!: number;
	nextRuntime!: number;
	status!: string;
	machinePresentInScan!: boolean;
	plateScanTypes!: Array<string>;
	plateScanDTO!: Array<PlateScanDTO>
	widgetEquipmentValues: Object = {};
	widgetChemicalLotValues: Object = {};
	triggerNextAction!: boolean;
	startwgapgx!: boolean;
	batching = false;
	unbatching = false;
	batches: string[];
	newBatchInfo: CreateBatchDTO;
	storagePlateIDs?: Array<string>;
}